import { useHookstate } from "@hookstate/core";
import { ChangeEvent, useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import { simpleGetter } from "../../actions/common";
import { demeritsApi } from "../../api/api";
import ArrowLeft from "../../assets/icons/ArrowLeft";
import { Stop } from "../../assets/icons/Stop";
import Tick from "../../assets/icons/Tick";
import UploadFile from "../../assets/icons/UploadFile";
import { useUniversalFind, useUniversalFindAll } from "../../hooks/universal";
import { dormBlacklistOptions } from "../../misc/constants";
import { showSnackbar } from "../../misc/utils";
import { accessGlobalMiscState, useGlobalMiscState } from "../../stores/misc";
import { DemeritType, DisciplinaryCase } from "../../types";
import { CustomDateInput } from "../CustomDateInput";
import { FileUploadWithPreview } from "../FileUploadWithPreview";
import { Switch } from "../Switch";
import DefaultButton from "../default-button/DefaultButton";
import InputField from "../input-field/InputField";
import { useDisciplinaryHearings } from "../../hooks/demerit";

export const FinaliseDisciplinaryCase = () => {
  const localState = useHookstate({
    form: {
      additional_files: {},
    },
  });
  const state: Record<string, any> = localState.get();
  const form = state.form || {};
  const miscState = useGlobalMiscState();
  const disciplinaryCasesDemeritCurrentCase: DisciplinaryCase =
    miscState.get("disciplinaryCasesDemeritCurrentCase") || {};
  const demeritTypes: DemeritType[] = useUniversalFindAll("DemeritType");
  const [protocolNumber, setProtocolNumber] = useState("");
  const allDisciplinaryHearings = useUniversalFind(
    "DisciplinaryHearing",
    {},
    {
      include: [
        {
          model: "DisciplinaryCase",
          as: "cases",
        },
      ],
      order: [["createdAt", "DESC"]],
    }
  );

  useEffect(() => {
    console.log(allDisciplinaryHearings);
  }, [allDisciplinaryHearings]);

  const onFormInputChangeNative =
    (key: string) => (e: React.ChangeEvent<HTMLInputElement>) => {
      //@ts-ignore
      localState.form[key].set(e.target.value);
    };

  const onFormInputChangeRaw = (key: string) => (value: any) => () => {
    //@ts-ignore
    localState.form[key].set(value);
  };

  const onFormInputChangeDate = (key: string) => (date: Date | null) => {
    //@ts-ignore
    localState.form[key].set(date);
  };

  const onFormInputChangeFile =
    (key: string) => (f: ChangeEvent<HTMLInputElement>) => {
      if (f.target.files?.length) {
        //@ts-ignore
        localState.form[key].set(f.target.files[0]);
      }
    };

  const onFormInputChangeFileRaw = (key: string) => (value: File | null) => {
    //@ts-ignore
    localState.form[key].set(value);
  };

  const onFormAdditionalFileChange =
    (key: string) => (f: ChangeEvent<HTMLInputElement>) => {
      if (f.target.files?.length) {
        //@ts-ignore
        localState.form.additional_files[key].set(f.target.files[0]);
      }
    };

  const onFormAdditionalFileChangeRaw =
    (key: string) => (value: File | null) => {
      //@ts-ignore
      localState.form.additional_files[key].set(value);
    };

  const onClose = () => {
    miscState.set("disciplinaryCasesFinaliseCaseModalOpen", false);
  };

  const onReject = async () => {
    if (!protocolNumber) {
      showSnackbar("Пожалуйста, введите номер протокола", "error");
      return;
    }
    const response = await simpleGetter(demeritsApi.updateDisciplinaryCase, {
      id: disciplinaryCasesDemeritCurrentCase.id,
      status: -2,
    });
    showSnackbar(
      response.success ? "Успешно" : "Произошла ошибка",
      response.success ? "success" : "error"
    );
    if (response.success) {
      accessGlobalMiscState().setBatch({
        disciplinaryCasesTriggerFetch:
          (accessGlobalMiscState().get("disciplinaryCasesTriggerFetch") || 0) +
          1,
        disciplinaryCasesFinaliseCaseModalOpen: false,
      });
    }
  };

  const addAdditionalFile = () => {
    const now = new Date().getTime();
    //@ts-ignore
    localState.form.additional_files[now].set("");
  };

  const onSubmit = async () => {
    const formData = new FormData();
    if (!protocolNumber) {
      showSnackbar("Пожалуйста, введите номер протокола", "error");
      return;
    }
    formData.append(
      "disciplinary_case_id",
      String(disciplinaryCasesDemeritCurrentCase.id)
    );
    formData.append("protocol_number", protocolNumber);
    for (const k in form) {
      if (k !== "additional_files" && form[k]) {
        formData.append(k, form[k]);
      }
    }

    for (const additionalFile in form.additional_files) {
      if (form.additional_files[additionalFile]) {
        formData.append(
          `additional_${additionalFile}`,
          form.additional_files[additionalFile]
        );
      }
    }
    const response = await simpleGetter(
      demeritsApi.submitDisciplinaryCaseProtocol,
      formData
    );
    showSnackbar(
      response.success ? "Успешно" : "Произошла ошибка",
      response.success ? "success" : "error"
    );
    if (response.success) {
      accessGlobalMiscState().setBatch({
        disciplinaryCasesTriggerFetch:
          (accessGlobalMiscState().get("disciplinaryCasesTriggerFetch") || 0) +
          1,
        disciplinaryCasesFinaliseCaseModalOpen: false,
      });
    }
  };

  const validateForm = () =>
    form.demerit_type_id && form.end_date && form.protocol;

  return (
    <div className='flex flex-col flex-1 overflow-y-auto'>
      <div>
        <p className='font-normal text-[15px] text-[#5F6B88]'>
          Завершение дела
        </p>
        <p className='text-black font-normal text-[24px]'>
          Дело №{disciplinaryCasesDemeritCurrentCase.id}.{" "}
          {disciplinaryCasesDemeritCurrentCase.name}
        </p>
      </div>
      <div className='flex flex-col gap-8 overflow-y-auto flex-1 my-8'>
        <div className='flex flex-col gap-6'>
          <InputField
            type='select'
            id='select-demerit-type'
            label='Тип нарушения'
            value={form.demerit_type_id || ""}
            handleChange={onFormInputChangeNative("demerit_type_id")}
            options={demeritTypes.map((d) => ({ value: d.id, label: d.name }))}
            additionalClassName='px-3 py-4 bg-valley-background-blue !rounded-lg'
            wrapperClassName='flex flex-col gap-2'
          />
          <div className='flex flex-row gap-6'>
            <div className='flex flex-col gap-2'>
              <p className='text-[#5F6B88] font-medium text-sm'>
                Окончание выговора
              </p>
              <DatePicker
                selected={form.end_date || ""}
                onChange={onFormInputChangeDate("end_date")}
                showYearDropdown
                scrollableYearDropdown
                customInput={<CustomDateInput hasTime={false} />}
                dateFormat='dd/MM/yyyy'
              />
            </div>
            {/* <p className="text-[#5F6B88] font-medium text-sm">Внести в чёрный список общежития?</p> */}
            <Switch
              switchClassName='!mt-0 py-0.5 h-auto border-valley-light-gray'
              labelClassName='!text-[#5F6B88] !font-medium !text-sm'
              wrapperClassName='flex-1 flex flex-col gap-2'
              id='club-status-switch'
              value={form.dorm_blacklist || 0}
              handleChange={onFormInputChangeRaw("dorm_blacklist")}
              label='Внести в чёрный список общежития?'
              options={dormBlacklistOptions}
            />
          </div>
        </div>
        <div className='flex flex-col gap-2'>
          <p className='text-[#5F6B88] font-medium text-sm'>Протокол</p>
          <InputField
            type='text'
            label='Дата протокола'
            value={(() => {
              const hearing = allDisciplinaryHearings.find((h: any) =>
                h.cases?.some(
                  (c: any) => c.id === disciplinaryCasesDemeritCurrentCase?.id
                )
              ) as any;
              return (
                `${new Date(hearing?.start_date).toLocaleDateString()}` || ""
              );
            })()}
            disabled
          />
          <InputField
            type='text'
            label='Номер протокола'
            value={protocolNumber}
            handleChange={(e) => {
              console.log(e.target.value);
              setProtocolNumber(e.target.value);
            }}
          />
          <FileUploadWithPreview
            mode='edit'
            value={form.protocol}
            updateValueRaw={onFormInputChangeFileRaw("protocol")}
            handleChange={onFormInputChangeFile("protocol")}
          />
        </div>
        <div className='flex flex-col flex-1 overflow-y-auto gap-2 min-h-[150px]'>
          <p className='text-[#5F6B88] font-medium text-sm'>
            Дополнительные материалы
          </p>
          <div className='flex flex-col flex-1 gap-2 overflow-y-auto rounded-lg border border-valley-light-gray p-4'>
            {Object.keys(form.additional_files)
              .filter((k) => form.additional_files[k] !== null)
              .map((k) => (
                <FileUploadWithPreview
                  wrapperClassName='flex-none'
                  mode='edit'
                  value={form.additional_files[k]}
                  updateValueRaw={onFormAdditionalFileChangeRaw(k)}
                  handleChange={onFormAdditionalFileChange(k)}
                />
              ))}
          </div>
          <button
            onClick={addAdditionalFile}
            className={`flex flex-row gap-2 justify-center items-center py-3 rounded-md border border-valley-main text-valley-main cursor-pointer`}
          >
            <UploadFile />
            <span className='text-[15px] font-semibold leading-[18px]'>
              Загрузить дополнительные материалы
            </span>
          </button>
        </div>
      </div>
      <div className='flex flex-row gap-3'>
        <DefaultButton
          buttonText='Вернуться'
          additionalStyle='flex-1 bg-[#5F6B88] text-white px-8 py-3 text-nowrap'
          Icon={ArrowLeft}
          onClick={onClose}
        />
        <DefaultButton
          buttonText='Сохранить'
          additionalStyle='flex-1 bg-valley-main text-white px-8 py-3 text-nowrap'
          Icon={Tick}
          onClick={onSubmit}
          disabled={!validateForm()}
        />
        <DefaultButton
          buttonText='Отменить'
          additionalStyle='flex-1 bg-[#F12D2D] text-white px-8 py-3 text-nowrap'
          Icon={Stop}
          onClick={onReject}
        />
      </div>
    </div>
  );
};
